import { memo } from 'react';
import Link from 'next/link';
import Button from '@components/Button/Button';
import Heading from '@components/Heading/Heading';
import styles from '@components/InfoCardWithMedia/InfoCardWithMedia.styles';
import { IInfoCardWithMedia } from '@components/typescript';
import RenderMedia from '@utils/RenderMedia';
import theme from '@styles/theme';
type PropsType = {
  infoCard: IInfoCardWithMedia;
};
const InfoCardWithMedia = memo(({
  infoCard
}: PropsType) => {
  const {
    images,
    videos,
    title,
    background,
    colorText,
    subtitle,
    link,
    buttonText
  } = infoCard;
  return <div sx={styles.infoCardContainer(background, colorText)}>
      <div sx={styles.infoCardImage}>{RenderMedia(images, videos, true, undefined, title)}</div>
      <div sx={styles.infoCardDescription}>
        <div>
          <Heading headingType={3} mobile pb={16} color={colorText || theme.rawColors.darkGrey700}>
            {title}
          </Heading>
          <p className="description">{subtitle}</p>
          {link && buttonText && <Link href={link}>
              <Button variantColor="dark" size="small" variant="outlined" addClassName="info_block-button" addSx={colorText ? {
            color: colorText,
            borderColor: colorText
          } : {}}>
                {buttonText}
              </Button>
            </Link>}
        </div>
      </div>
    </div>;
});
InfoCardWithMedia.displayName = 'InfoCardWithMedia';
export default InfoCardWithMedia;